import { Button } from 'react-bootstrap'

import { headerToIcon } from '@/components/CardLists/CardView/Sidebar'
import Icon from '@/components/Icon/Icon'
import { CardListType } from '@/types/card'
import { ComboData } from '@/types/page'
import { artCrop } from '@/utils/images'

import styles from './MetaData.module.scss'

type Props = {
  cardLists?: CardListType[]
  combo: ComboData
}

const PlayedWith = ({ cardLists, combo }: Props) => {
  if (!cardLists) return
  return (
    <div className={styles.infoContainer}>
      {combo.cardIds[0] && (
        <div className={styles.cornerContainer} style={{ backgroundImage: `url(${artCrop(combo.cardIds[0])})` }} />
      )}
      <h2 className={styles.header}>
        <Icon icon='link' />
        &nbsp;&nbsp;Played with this combo
      </h2>
      <div className={styles.statContainer}>
        {cardLists.slice(0, 4).map((cardList, i) => (
          <a href={`#${i === 0 ? 'cardlists' : cardList.tag}`} key={cardList.tag}>
            <Button className={styles.linkButton} variant='outline-primary'>
              {headerToIcon(cardList.header)} {cardList.header}
            </Button>
          </a>
        ))}
      </div>
    </div>
  )
}

export default PlayedWith
